module.exports = __webpack_public_path__ + "img/007.f8a60a33.png";